'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _FieldForm = require('../FieldForm');

var _FieldForm2 = _interopRequireDefault(_FieldForm);

var _FieldLabel = require('../FieldLabel');

var _FieldLabel2 = _interopRequireDefault(_FieldLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlankField = function (_React$Component) {
    (0, _inherits3.default)(BlankField, _React$Component);

    function BlankField() {
        (0, _classCallCheck3.default)(this, BlankField);
        return (0, _possibleConstructorReturn3.default)(this, (BlankField.__proto__ || (0, _getPrototypeOf2.default)(BlankField)).apply(this, arguments));
    }

    (0, _createClass3.default)(BlankField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                field = _props.field,
                input = _props.input,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ['field', 'input']);

            return _react2.default.createElement(field, (0, _extends3.default)({}, input, otherProps));
        }
    }]);
    return BlankField;
}(_react2.default.Component);

var BlankCheckboxField = function (_React$Component2) {
    (0, _inherits3.default)(BlankCheckboxField, _React$Component2);

    function BlankCheckboxField() {
        (0, _classCallCheck3.default)(this, BlankCheckboxField);
        return (0, _possibleConstructorReturn3.default)(this, (BlankCheckboxField.__proto__ || (0, _getPrototypeOf2.default)(BlankCheckboxField)).apply(this, arguments));
    }

    (0, _createClass3.default)(BlankCheckboxField, [{
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                title = _props2.title,
                field = _props2.field,
                label = _props2.label,
                checkboxLabel = _props2.checkboxLabel,
                input = _props2.input,
                otherProps = (0, _objectWithoutProperties3.default)(_props2, ['title', 'field', 'label', 'checkboxLabel', 'input']);

            var useLabel = label || checkboxLabel;

            var labelComponent = void 0;
            if (useLabel) {
                labelComponent = _react2.default.createElement(_FieldLabel2.default, { label: useLabel, title: title, component: 'span' });
            }

            return _react2.default.createElement(field, (0, _extends3.default)({}, input, {
                title: title
            }, otherProps, {
                label: labelComponent
            }));
        }
    }]);
    return BlankCheckboxField;
}(_react2.default.Component);

/**
 * Defaultní obal Field (redux-form) pro render s obalem FormField
 *
 * pokud je field = false vyrederuje se pouze daný input
 */


var Base = function (_React$Component3) {
    (0, _inherits3.default)(Base, _React$Component3);

    function Base() {
        (0, _classCallCheck3.default)(this, Base);
        return (0, _possibleConstructorReturn3.default)(this, (Base.__proto__ || (0, _getPrototypeOf2.default)(Base)).apply(this, arguments));
    }

    (0, _createClass3.default)(Base, [{
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                componentClass = _props3.componentClass,
                field = _props3.field,
                otherProps = (0, _objectWithoutProperties3.default)(_props3, ['componentClass', 'field']);

            var fieldComponent = void 0;
            var fieldProps = otherProps;
            if (field === false) {
                if (this.props.check) {
                    fieldComponent = BlankCheckboxField;
                } else {
                    fieldComponent = BlankField;
                }
            } else {
                fieldComponent = field;
            }
            return _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({ component: fieldComponent, field: componentClass }, fieldProps));
        }
    }]);
    return Base;
}(_react2.default.Component);

Base.PropTypes = {
    // componentClass: React.PropTypes.element.isRequired,
    // field: React.PropTypes.element
};
Base.defaultProps = {
    field: _FieldForm2.default
};
exports.default = Base;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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